var _path, _path2, _path3, _path4, _rect, _path5, _circle, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg515(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 48,
    viewBox: "0 0 136 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43397 8L0.144287 6.09914L2.56897 1.90086L5.86057 3.79844L5.86243 0H10.7119L10.7137 3.79844L14.0053 1.90086L16.43 6.09914L13.1403 8L16.43 9.90086L14.0053 14.0991L10.7137 12.2016L10.7119 16H5.86243L5.86057 12.2016L2.56897 14.0991L0.144287 9.90086L3.43397 8Z",
    fill: "#84CAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4301 0C46.307 0 44.5859 1.72109 44.5859 3.84415C44.5859 4.01629 44.4463 4.15585 44.2742 4.15585C42.1511 4.15585 40.4301 5.87692 40.4301 8C40.4301 10.1231 42.1511 11.8442 44.2742 11.8442C44.4463 11.8442 44.5859 11.9837 44.5859 12.1558C44.5859 14.2789 46.307 16 48.4301 16C50.5531 16 52.2742 14.2789 52.2742 12.1558C52.2742 11.9837 52.4138 11.8442 52.5859 11.8442C54.709 11.8442 56.4301 10.1231 56.4301 8C56.4301 5.87692 54.709 4.15585 52.5859 4.15585C52.4138 4.15585 52.2742 4.01629 52.2742 3.84415C52.2742 1.72109 50.5531 0 48.4301 0Z",
    fill: "#FFC3BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4623 0H95.8234C96.2671 3.55847 91.9832 4.41411 91.9832 8C91.9832 11.5859 96.2671 12.4415 95.8234 16H80.4623C80.0186 12.4415 84.3025 11.5859 84.3025 8C84.3025 4.41411 80.0186 3.55847 80.4623 0Z",
    fill: "#FDB022"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.856 0C121.646 0 119.856 1.79086 119.856 4C119.856 6.20917 121.646 8 123.856 8C121.646 8 119.856 9.79083 119.856 12C119.856 14.2092 121.646 16 123.856 16C126.065 16 127.856 14.2092 127.856 12C127.856 14.2092 129.646 16 131.856 16C134.065 16 135.856 14.2092 135.856 12C135.856 9.79083 134.065 8 131.856 8C134.065 8 135.856 6.20917 135.856 4C135.856 1.79086 134.065 0 131.856 0C129.646 0 127.856 1.79086 127.856 4C127.856 1.79086 126.065 0 123.856 0Z",
    fill: "#9B8AFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 16,
    height: 16,
    fill: "#FFBB25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32H56L53.3333 40L56 48H40L42.6667 40L40 32Z",
    fill: "#4F4F4F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 40,
    r: 8,
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.744 32H136L131.256 48H120L124.744 32Z",
    fill: "#56CCF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg515);
export default __webpack_public_path__ + "static/media/5-15.60471af90553d26bf4e16391f113b5d2.svg";
export { ForwardRef as ReactComponent };